// extracted by mini-css-extract-plugin
module.exports = {"Content":"Intro_Content__3V5xV","IntroImg":"Intro_IntroImg__2Xcjc"};